import Immutable from 'immutable';
import _ from 'underscore';

import FileInfo from 'sharedreact/data/FileInfo';

const placeHolderString = 'placeholder-fileinfolist';

const Content: {
  id: string,
  name: string,
  items: Immutable.List<FileInfo>,
} = {
  id: '',
  name: 'FileInfoList',
  items: Immutable.List()
};

class FileInfoList extends Immutable.Record(Content) {
  static createFromList(items: Immutable.List<FileInfo>): FileInfoList {
    return new FileInfoList({id: _.uniqueId(placeHolderString), items: items});
  }

  static createTemp(): FileInfoList {
    return new FileInfoList({id: _.uniqueId(placeHolderString)});
  }
}

export default FileInfoList;
